<template>
  <a-layout-footer class="footer">
    帅地刷题
  </a-layout-footer>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'the-footer',
});
</script>

<style>

.footer {
  text-align: center;
}

</style>
